

import { useParams, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function ProductDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('teknik-cizim');

  const products = [
    {
      id: 'alti-kose-basli-civata-din-933',
      name: 'Altı Köşe Başlı Cıvata DIN 933',
      category: 'Cıvata',
      description: 'Tam dişli altı köşe başlı cıvata, yüksek mukavemet sınıfı. Genel makine imalatı ve yapısal uygulamalarda kullanılır.',
      standard: 'DIN 933',
      material: 'Çelik 8.8, 10.9, 12.9',
      coating: 'Galvaniz, Siyah Oksit, Doğal',
      weight: '0.05-2.5 kg/adet',
      packaging: '100-500 adet/kutu',
      image: 'https://readdy.ai/api/search-image?query=High%20quality%20hex%20head%20bolts%20DIN%20933%20standard%20on%20dark%20metallic%20surface%2C%20professional%20industrial%20photography%20showing%20precision%20threading%20and%20hexagonal%20heads%2C%20various%20sizes%20of%20steel%20bolts%20with%20professional%20lighting%20highlighting%20quality%20craftsmanship%20and%20engineering%20precision&width=600&height=400&seq=hex-bolts-detail&orientation=landscape',
      technicalDrawing: 'https://www.enkacivata.com/storage/teknik-cizim/din-933-alti-kose-basli-civata.jpg',
      gallery: [
        'https://readdy.ai/api/search-image?query=Close-up%20view%20of%20hex%20head%20bolt%20threading%20and%20precision%20machining%20on%20dark%20metallic%20surface%2C%20professional%20macro%20photography%20showing%20detailed%20thread%20patterns%20and%20hexagonal%20head%20geometry%2C%20high%20quality%20steel%20finish%20with%20dramatic%20lighting&width=400&height=300&seq=hex-bolt-close&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Various%20sizes%20of%20hex%20head%20bolts%20arranged%20systematically%20on%20dark%20industrial%20surface%2C%20professional%20product%20photography%20showing%20size%20comparison%20and%20quality%20consistency%2C%20precision%20engineered%20fasteners%20with%20metallic%20finish&width=400&height=300&seq=hex-bolt-sizes&orientation=landscape'
      ],
      technicalSpecs: {
        'Standart': 'DIN 933 / ISO 4017',
        'Malzeme': 'Çelik 8.8, 10.9, 12.9',
        'Çap Aralığı': 'M3 - M100',
        'Uzunluk': '16mm - 1000mm',
        'Diş Adımı': 'Metrik standart',
        'Baş Yüksekliği': 'DIN 933 standardı',
        'Anahtar Ölçüsü': 'ISO 4762 uyumlu',
        'Kaplama': 'Galvaniz, Siyah Oksit',
        'Sıcaklık Dayanımı': '-40°C / +150°C',
        'Korozyon Dayanımı': 'Orta (kaplamalı)',
        'Ağırlık': '0.05-2.5 kg/adet',
        'Ambalaj': '100-500 adet/kutu'
      },
      dimensionTable: [
        { cap: 'M6', uzunluk: '16-80', basYuksekligi: '4.0', anahtarOlcusu: '10', disAdimi: '1.0' },
        { cap: 'M8', uzunluk: '20-100', basYuksekligi: '5.3', anahtarOlcusu: '13', disAdimi: '1.25' },
        { cap: 'M10', uzunluk: '25-120', basYuksekligi: '6.4', anahtarOlcusu: '17', disAdimi: '1.5' },
        { cap: 'M12', uzunluk: '30-140', basYuksekligi: '7.5', anahtarOlcusu: '19', disAdimi: '1.75' },
        { cap: 'M16', uzunluk: '40-160', basYuksekligi: '10.0', anahtarOlcusu: '24', disAdimi: '2.0' },
        { cap: 'M20', uzunluk: '50-200', basYuksekligi: '12.5', anahtarOlcusu: '30', disAdimi: '2.5' }
      ],
      applications: [
        'Makine imalatı ve montajı',
        'Çelik konstrüksiyon bağlantıları',
        'Otomotiv endüstrisi',
        'Genel endüstriyel uygulamalar',
        'Yapısal çelik bağlantıları'
      ],
      standards: [
        'DIN 933 - Altı köşe başlı cıvatalar',
        'ISO 4017 - Tam dişli cıvatalar',
        'EN 24017 - Avrupa standardı',
        'ASTM A325 - Yapısal cıvatalar'
      ]
    },
    {
      id: 'alti-kose-basli-civata-din-931',
      name: 'Altı Köşe Başlı Cıvata DIN 931',
      category: 'Cıvata',
      description: 'Kısmi dişli altı köşe başlı cıvata, yapısal uygulamalar için ideal. Yüksek mukavemet gerektiren bağlantılarda kullanılır.',
      standard: 'DIN 931',
      material: 'Çelik 8.8, 10.9',
      coating: 'Galvaniz, Sıcak Daldırma Galvaniz',
      weight: '0.08-4.2 kg/adet',
      packaging: '50-200 adet/kutu',
      image: 'https://readdy.ai/api/search-image?query=Hex%20head%20bolts%20DIN%20931%20partial%20thread%20on%20dark%20industrial%20surface%2C%20professional%20photography%20showing%20structural%20bolts%20with%20hexagonal%20heads%20high%20strength%20steel%20construction%20with%20precision%20engineering&width=600&height=400&seq=hex-bolts-931-detail&orientation=landscape',
      technicalDrawing: 'https://www.enkacivata.com/storage/teknik-cizim/din-931-alti-kose-basli-civata.jpg',
      gallery: [
        'https://readdy.ai/api/search-image?query=Close-up%20view%20of%20DIN%20931%20partial%20thread%20bolt%20showing%20thread%20detail%20and%20smooth%20shank%2C%20professional%20macro%20photography%20with%20industrial%20lighting&width=400&height=300&seq=din931-close&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Various%20sizes%20of%20DIN%20931%20bolts%20arranged%20systematically%20showing%20partial%20thread%20design%2C%20professional%20product%20photography&width=400&height=300&seq=din931-sizes&orientation=landscape'
      ],
      technicalSpecs: {
        'Standart': 'DIN 931 / ISO 4014',
        'Malzeme': 'Çelik 8.8, 10.9',
        'Çap Aralığı': 'M8 - M100',
        'Uzunluk': '25mm - 1000mm',
        'Diş Uzunluğu': '2d + 6mm',
        'Baş Yüksekliği': 'DIN 931 standardı',
        'Anahtar Ölçüsü': 'ISO 4762 uyumlu',
        'Kaplama': 'Galvaniz, Sıcak Daldırma',
        'Sıcaklık Dayanımı': '-40°C / +150°C',
        'Korozyon Dayanımı': 'Yüksek (galvaniz)',
        'Ağırlık': '0.08-4.2 kg/adet',
        'Ambalaj': '50-200 adet/kutu'
      },
      dimensionTable: [
        { cap: 'M8', uzunluk: '25-120', basYuksekligi: '5.3', anahtarOlcusu: '13', disAdimi: '1.25' },
        { cap: 'M10', uzunluk: '30-140', basYuksekligi: '6.4', anahtarOlcusu: '17', disAdimi: '1.5' },
        { cap: 'M12', uzunluk: '35-160', basYuksekligi: '7.5', anahtarOlcusu: '19', disAdimi: '1.75' },
        { cap: 'M16', uzunluk: '40-200', basYuksekligi: '10.0', anahtarOlcusu: '24', disAdimi: '2.0' },
        { cap: 'M20', uzunluk: '50-250', basYuksekligi: '12.5', anahtarOlcusu: '30', disAdimi: '2.5' },
        { cap: 'M24', uzunluk: '60-300', basYuksekligi: '15.0', anahtarOlcusu: '36', disAdimi: '3.0' }
      ],
      applications: [
        'Çelik yapı bağlantıları',
        'Ağır makine montajı',
        'Köprü ve bina konstrüksiyonu',
        'Endüstriyel ekipman montajı',
        'Yüksek mukavemet gerektiren uygulamalar'
      ],
      standards: [
        'DIN 931 - Kısmi dişli cıvatalar',
        'ISO 4014 - Altı köşe başlı cıvatalar',
        'EN 24014 - Avrupa standardı',
        'ASTM A325 - Yapısal cıvatalar'
      ]
    },
    // ... other product objects omitted for brevity ...
    {
      id: 'alti-kose-somun-din-934',
      name: 'Altı Köşe Somun DIN 934',
      category: 'Somun',
      description: 'Standart altı köşe somun, genel kullanım',
      standard: 'DIN 934',
      material: 'Çelik, Paslanmaz Çelik',
      coating: 'Çinko Kaplama, Doğal',
      weight: '0.001-0.5 kg/adet',
      packaging: '500-5000 adet/kutu',
      image: 'https://readdy.ai/api/search-image?query=Hexagonal%20nuts%20DIN%20934%20standard%20arranged%20on%20dark%20industrial%20surface%2C%20professional%20product%20photography%20showing%20six-sided%20design%20and%20internal%20threading%2C%20stainless%20steel%20and%20zinc%20plated%20finishes%20with%20metallic%20reflections&width=600&height=400&seq=hex-nuts-detail&orientation=landscape',
      technicalDrawing: 'https://www.enkacivata.com/storage/teknik-cizim/din-934-alti-kose-somun.jpg',
      gallery: [
        'https://readdy.ai/api/search-image?query=Close-up%20macro%20view%20of%20hex%20nut%20showing%20internal%20threading%20and%20precision%20machining%2C%20professional%20photography%20with%20industrial%20lighting&width=400&height=300&seq=hex-nut-close&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Various%20sizes%20of%20hex%20nuts%20arranged%20systematically%20showing%20size%20progression%20and%20quality%20consistency&width=400&height=300&seq=hex-nut-sizes&orientation=landscape'
      ],
      technicalSpecs: {
        'Standart': 'DIN 934 / ISO 4032',
        'Malzeme': 'Çelik 8, Paslanmaz A2-A4',
        'Çap Aralığı': 'M3 - M100',
        'Yükseklik': 'DIN 934 standardı',
        'Anahtar Ölçüsü': 'Metrik standart',
        'Diş Adımı': 'Metrik standart',
        'Mukavemet': '8 (800 N/mm²)',
        'Sıcaklık Dayanımı': '-40°C / +150°C',
        'Yüzey İşlemi': 'Galvaniz, Doğal',
        'Korozyon Dayanımı': 'Orta-Yüksek',
        'Ağırlık': '0.001-0.5 kg/adet',
        'Ambalaj': '500-5000 adet/kutu'
      },
      dimensionTable: [
        { cap: 'M3', yukseklik: '2.4', anahtarOlcusu: '5.5', disAdimi: '0.5' },
        { cap: 'M4', yukseklik: '3.2', anahtarOlcusu: '7', disAdimi: '0.7' },
        { cap: 'M5', yukseklik: '4.0', anahtarOlcusu: '8', disAdimi: '0.8' },
        { cap: 'M6', yukseklik: '5.0', anahtarOlcusu: '10', disAdimi: '1.0' },
        { cap: 'M8', yukseklik: '6.5', anahtarOlcusu: '13', disAdimi: '1.25' },
        { cap: 'M10', yukseklik: '8.0', anahtarOlcusu: '17', disAdimi: '1.5' }
      ],
      applications: [
        'Genel makine montajı',
        'Yapısal bağlantılar',
        'Otomotiv uygulamaları',
        'Elektronik ekipmanlar',
        'Endüstriyel montajlar'
      ],
      standards: [
        'DIN 934 - Altı köşe somunlar',
        'ISO 4032 - Hex nuts',
        'ASTM A563 - Amerikan standardı',
        'JIS B1181 - Japon standardı'
      ]
    }
    // ... other products ...
  ];

  const product = products.find(p => p.id === id);

  if (!product) {
    return (
      <div className="min-h-screen">
        <Header />
        <main className="py-20">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-3xl font-bold text-slate-800 mb-4">Ürün Bulunamadı</h1>
            <p className="text-gray-600 mb-8">Aradığınız ürün mevcut değil.</p>
            <Button onClick={() => navigate('/urunler')}>
              Ürünlere Geri Dön
            </Button>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  const tabs = [
    { id: 'olcu-tablosu', label: 'Ölçü Tablosu', icon: 'ri-table-line' },
    { id: 'ozellikler', label: 'Teknik Özellikler', icon: 'ri-settings-line' },
    { id: 'uygulamalar', label: 'Uygulama Alanları', icon: 'ri-tools-line' },
    { id: 'standartlar', label: 'Standartlar', icon: 'ri-award-line' }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Breadcrumb */}
        <section className="py-4 bg-gray-50">
          <div className="container mx-auto px-4">
            <nav className="flex items-center space-x-2 text-sm">
              <button
                onClick={() => navigate('/')}
                className="text-gray-500 hover:text-orange-500 cursor-pointer transition-colors duration-200"
              >
                Ana Sayfa
              </button>
              <i className="ri-arrow-right-s-line text-gray-400"></i>
              <button
                onClick={() => navigate('/urunler')}
                className="text-gray-500 hover:text-orange-500 cursor-pointer transition-colors duration-200"
              >
                Ürünler
              </button>
              <i className="ri-arrow-right-s-line text-gray-400"></i>
              <span className="text-orange-5

0 font-medium">{product.name}</span>
            </nav>
          </div>
        </section>

        {/* Product Detail */}
        <section className="py-12 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              {/* Product Images */}
              <div>
                <div className="mb-4">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-96 object-cover object-top rounded-lg shadow-lg"
                  />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  {product.gallery?.map((image, index) => (
                    <img
                      key={index}
                      src={image}
                      alt={`${product.name} ${index + 1}`}
                      className="w-full h-32 object-cover object-top rounded-lg shadow cursor-pointer hover:shadow-lg transition-shadow duration-200"
                    />
                  ))}
                </div>
              </div>

              {/* Product Info */}
              <div className="lg:col-span-1">
                <div className="sticky top-8">
                  <h1 className="text-3xl font-bold text-gray-900 mb-4">{product.name}</h1>

                  <div className="flex items-center space-x-4 mb-6">
                    <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">
                      {product.standard}
                    </span>
                    <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
                      Stokta
                    </span>
                  </div>

                  <div className="prose prose-gray max-w-none mb-6">
                    <p className="text-gray-600 leading-relaxed">{product.description}</p>
                  </div>

                  {/* Quick Specs */}
                  <div className="bg-gray-50 rounded-lg p-4 mb-6">
                    <h3 className="font-semibold text-gray-900 mb-3">Hızlı Özellikler</h3>
                    <div className="grid grid-cols-1 gap-3 text-sm">
                      <div>
                        <span className="text-gray-500">Malzeme:</span>
                        <span className="ml-2 font-medium">{product.material}</span>
                      </div>
                      <div>
                        <span className="text-gray-500">Kaplama:</span>
                        <span className="ml-2 font-medium">{product.coating}</span>
                      </div>
                      <div>
                        <span className="text-gray-500">Ağırlık:</span>
                        <span className="ml-2 font-medium">{product.weight}</span>
                      </div>
                      <div>
                        <span className="text-gray-500">Ambalaj:</span>
                        <span className="ml-2 font-medium">{product.packaging}</span>
                      </div>
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="space-y-3">
                    <button className="w-full border border-gray-300 text-gray-700 py-3 px-6 rounded-lg font-semibold hover:bg-gray-50 transition-colors whitespace-nowrap">
                      <i className="ri-share-line mr-2"></i>
                      Paylaş
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Product Details Tabs */}
        <section className="py-12 bg-gray-50">
          <div className="container mx-auto px-4">
            {/* Tab Navigation */}
            <div className="flex justify-center mb-8 overflow-x-auto">
              <div className="flex bg-white rounded-lg p-1 shadow min-w-max">
                {tabs.map(tab => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`flex items-center px-6 py-4 rounded-lg text-base font-bold transition-all duration-200 whitespace-nowrap cursor-pointer ${
                      activeTab === tab.id
                        ? 'bg-orange-500 text-white border-b-2 border-orange-500'
                        : 'text-slate-800 hover:text-orange-500 hover:bg-orange-50'
                    }`}
                  >
                    <i className={`${tab.icon} mr-2`}></i>
                    {tab.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Tab Content */}
            <div className="max-w-6xl mx-auto">
              {/* Ölçü Tablosu */}
              {activeTab === 'olcu-tablosu' && (
                <div className="bg-white rounded-lg p-8 shadow">
                  <h3 className="text-2xl font-bold text-slate-800 mb-6">Ölçü Tablosu</h3>
                  {product.dimensionTable ? (
                    <div className="space-y-8">
                      {/* Teknik Bilgiler Tablosu */}
                      <div>
                        <h4 className="text-xl font-semibold text-slate-800 mb-4">
                          Technical Informations / Teknik Bilgiler
                        </h4>
                        <div className="overflow-x-auto">
                          <table className="w-full border-collapse border border-gray-300">
                            <thead>
                              <tr className="bg-gray-100">
                                <th className="border border-gray-300 px-4 py-3 text-left font-semibold">
                                  Çap (mm)
                                </th>
                                <th className="border border-gray-300 px-4 py-3 text-left font-semibold">
                                  Diş Adımı (mm)
                                </th>
                                <th className="border border-gray-300 px-4 py-3 text-left font-semibold">
                                  Kafa Yüksekliği (mm)
                                </th>
                                <th className="border border-gray-300 px-4 py-3 text-left font-semibold">
                                  Kafa Çapı (mm)
                                </th>
                                <th className="border border-gray-300 px-4 py-3 text-left font-semibold">
                                  Soket Genişliği (mm)
                                </th>
                                <th className="border border-gray-300 px-4 py-3 text-left font-semibold">
                                  Soket Derinliği (mm)
                                </th>
                                <th className="border border-gray-300 px-4 py-3 text-left font-semibold">
                                  Diş Uzunluğu (mm)
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {product.dimensionTable.map((row, idx) => (
                                <tr
                                  key={row.cap}
                                  className={idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
                                >
                                  <td className="border border-gray-300 px-4 py-3 font-medium">{row.cap}</td>
                                  <td className="border border-gray-300 px-4 py-3">{row.disAdimi || '-'}</td>
                                  <td className="border border-gray-300 px-4 py-3">{row.basYuksekligi || '-'}</td>
                                  <td className="border border-gray-300 px-4 py-3">{row.cap}</td>
                                  <td className="border border-gray-300 px-4 py-3">{row.anahtarOlcusu || '-'}</td>
                                  <td className="border border-gray-300 px-4 py-3">{'-'}</td>
                                  <td className="border border-gray-300 px-4 py-3">{'-'}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      {/* Optional Weight Table */}
                      <div>
                        <h4 className="text-xl font-semibold text-slate-800 mb-4">
                          1000 ADETİN KG AĞIRLIĞI
                        </h4>
                        <p className="text-gray-600">
                          Bu ürün için ağırlık tablosu henüz eklenmedi. Lütfen ilerleyen güncellemeler için bekleyiniz.
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div className="text-center py-12">
                      <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
                        <i className="ri-table-line text-2xl text-gray-400"></i>
                      </div>
                      <h4 className="text-lg font-semibold text-gray-600 mb-2">
                        Ölçü Tablosu Hazırlanıyor
                      </h4>
                      <p className="text-gray-500">
                        Bu ürün için detaylı ölçü tablosu yakında eklenecektir.
                      </p>
                    </div>
                  )}
                </div>
              )}
              {/* Teknik Özellikler */}
              {activeTab === 'ozellikler' && (
                <div className="bg-white rounded-lg p-8 shadow">
                  <h3 className="text-2xl font-bold text-slate-800 mb-6">Teknik Özellikler</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <div className="font-semibold text-slate-800 mb-1">Malzeme</div>
                      <div className="text-gray-700">{product.material}</div>
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <div className="font-semibold text-slate-800 mb-1">Kaplama</div>
                      <div className="text-gray-700">{product.coating}</div>
                    </div>
                  </div>
                </div>
              )}
              {/* Uygulama Alanları */}
              {activeTab === 'uygulamalar' && (
                <div className="bg-white rounded-lg p-8 shadow">
                  <h3 className="text-2xl font-bold text-slate-800 mb-6">Uygulama Alanları</h3>
                  {product.applications ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {product.applications.map((application, index) => (
                        <div
                          key={index}
                          className="flex items-center p-4 bg-gray-50 rounded-lg"
                        >
                          <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center mr-4">
                            <i className="ri-check-line text-orange-500"></i>
                          </div>
                          <span className="text-slate-800 font-medium">{application}</span>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="flex items-center p-4 bg-gray-50 rounded-lg">
                        <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center mr-4">
                          <i className="ri-check-line text-orange-500"></i>
                        </div>
                        <span className="text-slate-800 font-medium">
                          Genel endüstriyel uygulamalar
                        </span>
                      </div>
                      <div className="flex items-center p-4 bg-gray-50 rounded-lg">
                        <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center mr-4">
                          <i className="ri-check-line text-orange-500"></i>
                        </div>
                        <span className="text-slate-800 font-medium">Makine montajı</span>
                      </div>
                      <div className="flex items-center p-4 bg-gray-50 rounded-lg">
                        <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center mr-4">
                          <i className="ri-check-line text-orange-500"></i>
                        </div>
                        <span className="text-slate-800 font-medium">Yapısal bağlantılar</span>
                      </div>
                      <div className="flex items-center p-4 bg-gray-50 rounded-lg">
                        <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center mr-4">
                          <i className="ri-check-line text-orange-500"></i>
                        </div>
                        <span className="text-slate-800 font-medium">Otomotiv sektörü</span>
                      </div>
                    </div>
                  )}
                </div>
              )}
              {/* Standartlar */}
              {activeTab === 'standartlar' && (
                <div className="bg-white rounded-lg p-8 shadow">
                  <h3 className="text-2xl font-bold text-slate-800 mb-6">Standartlar ve Normlar</h3>
                  {product.standards ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {product.standards.map((standard, index) => (
                        <div
                          key={index}
                          className="flex items-center p-4 bg-gray-50 rounded-lg"
                        >
                          <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mr-4">
                            <i className="ri-award-line text-green-500"></i>
                          </div>
                          <span className="text-slate-800 font-medium">{standard}</span>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="flex items-center p-4 bg-gray-50 rounded-lg">
                        <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mr-4">
                          <i className="ri-award-line text-green-500"></i>
                        </div>
                        <span className="text-slate-800 font-medium">{product.standard} - Ana standart</span>
                      </div>
                      <div className="flex items-center p-4 bg-gray-50 rounded-lg">
                        <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mr-4">
                          <i className="ri-award-line text-green-500"></i>
                        </div>
                        <span className="text-slate-800 font-medium">ISO Kalite Standardı</span>
                      </div>
                      <div className="flex items-center p-4 bg-gray-50 rounded-lg">
                        <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mr-4">
                          <i className="ri-award-line text-green-500"></i>
                        </div>
                        <span className="text-slate-800 font-medium">CE Uygunluk Beyanı</span>
                      </div>
                      <div className="flex items-center p-4 bg-gray-50 rounded-lg">
                        <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mr-4">
                          <i className="ri-award-line text-green-500"></i>
                        </div>
                        <span className="text-slate-800 font-medium">Avrupa Standardı</span>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </section>

        {/* Related Products */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-12">
              <h2
                className="text-3xl font-bold text-slate-800 mb-4"
                style={{ fontFamily: 'Exo 2, sans-serif' }}
              >
                Benzer Ürünler
              </h2>
              <p className="text-gray-600">Aynı kategorideki diğer ürünlerimizi keşfedin</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {products
                .filter(p => p.id !== product.id && p.category === product.category)
                .slice(0, 3)
                .map(relatedProduct => (
                  <div
                    key={relatedProduct.id}
                    className="bg-gray-50 rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 group"
                  >
                    <div className="relative overflow-hidden">
                      <img
                        src={relatedProduct.image}
                        alt={relatedProduct.name}
                        className="w-full h-48 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                      />
                      <div className="absolute top-4 right-4">
                        <span className="bg-blue-600 text-white px-2 py-1 rounded text-xs font-medium">
                          {relatedProduct.standard}
                        </span>
                      </div>
                    </div>
                    <div className="p-6">
                      <h3 className="text-xl font-bold text-slate-800 mb-2">{relatedProduct.name}</h3>
                      <p className="text-gray-600 mb-4">{relatedProduct.description}</p>
                      <Button
                        variant="outline"
                        size="sm"
                        className="w-full"
                        onClick={() => navigate(`/urun/${relatedProduct.id}`)}
                      >
                        <i className="ri-information-line mr-2"></i>
                        Teknik Detaylar
                      </Button>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

